import reducer from './topClientsMonthlyConsumptionReducer';
import actions from './topClientsMonthlyConsumptionActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
